fx.ns("shared.renderers", class EffectRenderer extends fx.Component {
    
	constructor(data)
	{
      super(data);
  }

  render()
  {
      let html ="<img class='image' src='" + this.data.thumb + "'></img>";
      html += "<div class='text'>" + this.data.label+ "</div>";
      return html;
  }

}); 